import { useQuery } from '@tanstack/react-query';
import { createSubscriptionQuery } from 'shared/lib/@tanstack-query';
import { getExternalCalendarConnectionsQuery } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

const queryKey = 'external-calendar-connections';

export const useExternalCalendarConnectionsQuery = (uid?: ID) =>
  useQuery({
    queryKey: [queryKey, uid ?? ''],
    queryFn: createSubscriptionQuery([
      () => getExternalCalendarConnectionsQuery(),
    ]),
    enabled: !!uid,
  });
